import { render, staticRenderFns } from "./KerstinVideos.vue?vue&type=template&id=c5accc32"
import script from "./KerstinVideos.vue?vue&type=script&lang=js"
export * from "./KerstinVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports